<admin-layout pageTitle="Início">
    <section class="home">
        <div class="home-head">
            <div>
                <h2>Painel do dia</h2>
                <p>
                    @if (dashboardOk) {
                    Cadastros, uso do app, controles leiteiros e integração SRG-SCL
                    } @else {
                    API <strong>{{ envLabel }}</strong> — cadastros reais; métricas de uso/SRG
                    indisponíveis nesta API (use Homologação para o painel completo)
                    }
                </p>
            </div>
            <button mat-stroked-button type="button" (click)="refresh()" [disabled]="loading">
                <mat-icon>refresh</mat-icon>
                Atualizar
            </button>
        </div>

        @if (loading) {
        <div class="loading"><mat-spinner diameter="36"></mat-spinner></div>
        }

        <div class="kpis">
            <button type="button" class="kpi" (click)="navigateToProducers()">
                <span class="kpi-label">Produtores</span>
                <b>{{ producers | number }}</b>
                <span class="kpi-hint">cadastros ativos</span>
            </button>
            <div class="kpi kpi-scoped">
                <button type="button" class="kpi-main" (click)="navigateToControllers()">
                    <span class="kpi-label">Controladores</span>
                    <b>{{ controllersKpi.linked | number }}</b>
                    <span class="kpi-hint">com produtor · {{ controllersKpi.total | number }} {{ controllersScopeHint }}</span>
                </button>
                <div class="kpi-scope" role="group" aria-label="Filtrar controladores">
                    @for (opt of controllersScopes; track opt) {
                    <button
                        type="button"
                        [attr.aria-pressed]="controllersScope === opt"
                        [class.is-on]="controllersScope === opt"
                        (click)="setControllersScope(opt)"
                    >
                        {{ opt === 'ativos' ? 'Ativos' : opt === 'inativos' ? 'Inativos' : 'Todos' }}
                    </button>
                    }
                </div>
            </div>
            <button type="button" class="kpi" (click)="navigateToBreeders()">
                <span class="kpi-label">Reprodutores</span>
                <b>{{ breeders | number }}</b>
                <span class="kpi-hint">no cadastro</span>
            </button>
            <button
                type="button"
                class="kpi"
                [class.kpi-alert]="integrationOk && syncFailed + outboxFailed > 0"
                [class.kpi-muted]="!integrationOk"
                (click)="navigateToMonitor()"
                [disabled]="!integrationOk"
            >
                <span class="kpi-label">Falhas integração</span>
                <b>{{ integrationOk ? (syncFailed + outboxFailed | number) : 'n/d' }}</b>
                <span class="kpi-hint">{{ integrationOk ? 'animais + eventos' : 'só no HML' }}</span>
            </button>
        </div>

        <div class="stats-row">
            <div class="stat" [class.stat-na]="!dashboardOk">
                <span>Controles hoje</span>
                <b>{{ dashboardOk ? (milkToday | number) : 'n/d' }}</b>
            </div>
            <div class="stat" [class.stat-na]="!dashboardOk">
                <span>Controles (7 dias)</span>
                <b>{{ dashboardOk ? (milkWeek | number) : 'n/d' }}</b>
            </div>
            <div class="stat" [class.stat-na]="!dashboardOk">
                <span>Controles abertos</span>
                <b [class.crit]="dashboardOk && milkOpen > 0">{{
                    dashboardOk ? (milkOpen | number) : 'n/d'
                }}</b>
            </div>
            <div class="stat">
                <span>Contas de login</span>
                <b>{{ usersTotal | number }}</b>
                @if (dashboardOk && (usersProducer || usersController)) {
                <small
                    >{{ usersProducer | number }} prod. · {{ usersController | number }} ctrl.</small
                >
                } @else if (!dashboardOk) {
                <small>total (sem breakdown nesta API)</small>
                }
            </div>
            <div class="stat" [class.stat-na]="!integrationOk">
                <span>Pendentes de sync</span>
                <b>{{ integrationOk ? (syncPending | number) : 'n/d' }}</b>
            </div>
            <div class="stat" [class.stat-na]="!integrationOk">
                <span>Eventos na fila</span>
                <b>{{ integrationOk ? (outboxPending | number) : 'n/d' }}</b>
            </div>
            <div class="stat" [class.stat-na]="!integrationOk">
                <span>Eventos com erro</span>
                <b class="crit">{{ integrationOk ? (outboxFailed | number) : 'n/d' }}</b>
            </div>
            <div class="stat" [class.stat-na]="!integrationOk">
                <span>Animais enviados</span>
                <b>{{ integrationOk ? (syncSynced | number) : 'n/d' }}</b>
            </div>
        </div>

        <div class="home-grid">
            <div class="home-stack">
            <section class="panel">
                <h2>Quem mais usa o app</h2>
                <p class="panel-sub">
                    @if (dashboardOk) { Ações feitas com o login do próprio produtor, últimos {{ periodDays }} dias
                    } @else { Ranking de uso exige /admin-dashboard (só Homologação) }
                </p>
                @if (topProducers.length === 0) {
                <p class="empty">
                    {{
                        dashboardOk || integrationOk
                            ? 'Sem atividade recente para ranquear.'
                            : 'Indisponível nesta API.'
                    }}
                </p>
                } @else {
                <ol class="rank">
                    @for (row of topProducers; track row.id + row.code; let i = $index) {
                    <li>
                        <button type="button" class="rank-row" (click)="go(row.route || '/producers')">
                            <span class="rank-pos">{{ i + 1 }}</span>
                            <span class="rank-main">
                                <b>{{ row.name }}</b>
                                <small>Código {{ row.code }}</small>
                            </span>
                            <span class="rank-metric">
                                <b>{{ row.actions | number }}</b>
                                <small>ações</small>
                            </span>
                        </button>
                    </li>
                    }
                </ol>
                }
            </section>

            <section class="panel">
                <h2>Sem atividade</h2>
                <p class="panel-sub">
                    @if (dashboardOk) { Produtores há mais tempo sem ações com o próprio login. Ações contadas desde a implantação desta versão
                    } @else { Exige /admin-dashboard (só Homologação) }
                </p>
                @if (!inactivityOk) {
                <p class="empty">Indisponível nesta API.</p>
                } @else if (inactivity.length === 0) {
                <p class="empty">A análise de inatividade não retornou produtores.</p>
                } @else {
                <ol class="rank">
                    @for (row of inactivityTop; track row.id) {
                    <li>
                        <button type="button" class="rank-row" (click)="go(['/producers', row.id])">
                            <span class="rank-main">
                                <b>{{ row.name }}</b>
                                <small>
                                    Código {{ row.code }} · último login
                                    {{ row.daysWithoutLogin === null || row.daysWithoutLogin === undefined ? 'sem registro' : 'há ' + row.daysWithoutLogin + ' dia(s)' }}
                                </small>
                            </span>
                            <span class="rank-metric">
                                <b>
                                    {{ row.daysWithoutAction === null || row.daysWithoutAction === undefined ? 'Nunca' : row.daysWithoutAction + ' d' }}
                                </b>
                                <small>sem ação</small>
                            </span>
                        </button>
                    </li>
                    }
                </ol>
                }
            </section>
            </div>

            <section class="panel panel-controllers">
                <h2>Controladores</h2>
                <p class="panel-sub">
                    {{ controllersRanking.length | number }} {{ controllersScopeHint }}
                    @if (dashboardOk) { · ações nos últimos {{ periodDays }} dias } @else { · ranking de ações exige /admin-dashboard }
                </p>
                @if (controllersRanking.length === 0) {
                <p class="empty">Nenhum controlador nesta lista.</p>
                } @else {
                <ol class="rank">
                    @for (row of controllersRanking.slice(0, controllersShown); track row.id; let i = $index) {
                    <li>
                        <button type="button" class="rank-row" (click)="go('/controller')">
                            <span class="rank-pos">{{ i + 1 }}</span>
                            <span class="rank-main">
                                <b>{{ row.name }}</b>
                                <small>
                                    Código {{ row.code }} · {{ row.producers | number }} produtor(es)
                                    @if (!row.active) { · <span class="tag-off">inativo</span> }
                                </small>
                            </span>
                            <span class="rank-metric">
                                @if (dashboardOk) {
                                <b>{{ row.actions | number }}</b>
                                <small>ações</small>
                                } @else {
                                <b>{{ row.producers | number }}</b>
                                <small>produtores</small>
                                }
                            </span>
                        </button>
                    </li>
                    }
                </ol>
                <div class="rank-foot">
                    @if (controllersRanking.length > controllersShown) {
                    <button type="button" class="rank-more" (click)="showMoreControllers()">
                        Mostrar mais ({{ controllersRanking.length - controllersShown | number }} restantes)
                    </button>
                    }
                    <button type="button" class="rank-more rank-more-link" (click)="navigateToControllers()">
                        Abrir lista completa
                    </button>
                </div>
                }
            </section>
        </div>

        <div class="home-grid home-grid-bottom">
            <section class="panel">
                <h2>Atalhos</h2>
                <div class="shortcuts">
                    <button type="button" class="shortcut" (click)="navigateToProducers()">
                        <span class="shortcut-ico"><mat-icon>person</mat-icon></span>
                        <span>
                            <b>Produtores</b>
                            <small>Cadastro, animais, usuários e sync</small>
                        </span>
                    </button>
                    <button type="button" class="shortcut" (click)="navigateToControllers()">
                        <span class="shortcut-ico"><mat-icon>badge</mat-icon></span>
                        <span>
                            <b>Controladores</b>
                            <small>Quem atende cada rebanho</small>
                        </span>
                    </button>
                    <button type="button" class="shortcut" (click)="navigateToBreeders()">
                        <span class="shortcut-ico"><mat-icon>pets</mat-icon></span>
                        <span>
                            <b>Reprodutores</b>
                            <small>Touros, empresa e códigos</small>
                        </span>
                    </button>
                    <button type="button" class="shortcut" (click)="navigateToSettings()">
                        <span class="shortcut-ico"><mat-icon>settings</mat-icon></span>
                        <span>
                            <b>SRG-SCL</b>
                            <small>URL, token e habilitação</small>
                        </span>
                    </button>
                    <button type="button" class="shortcut" (click)="navigateToMonitor()">
                        <span class="shortcut-ico"><mat-icon>monitor_heart</mat-icon></span>
                        <span>
                            <b>Monitoramento</b>
                            <small>Falhas, fila e reenvio</small>
                        </span>
                    </button>
                </div>
            </section>

            <section class="panel">
                <h2>Precisa atenção</h2>
                @for (item of attentionItems; track item.title) {
                <button
                    type="button"
                    class="attention"
                    [class.crit]="item.tone === 'crit'"
                    (click)="go(item.route)"
                >
                    <b>{{ item.title }}</b>
                    <small>{{ item.detail }}</small>
                </button>
                }
            </section>
        </div>
    </section>
</admin-layout>
